import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Home', href: '#' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#1a1a1a] shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-32">
        {/* Logo */}
        <a href="#" className="flex items-center cursor-pointer">
          <img
            src="https://storage.readdy-site.link/project_files/d22c6399-eb7f-4911-8e5b-8acfdada154e/b8a83447-7c28-4bdb-882a-4824783c4ae8_logo.webp?v=39bdc8d05d88a7fa016d38d80d5cdc5e"
            alt="PRA Roof Contractors, Inc."
            className="h-28 w-auto object-contain brightness-200"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-white/80 hover:text-white text-sm font-medium transition-colors duration-200 whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="tel:2813779180"
            className="flex items-center gap-2 bg-[#c0392b] hover:bg-[#a93226] text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line text-sm"></i>
            (281) 377-9180
          </a>
          <a
            href="#contact"
            className="bg-white/10 hover:bg-white/20 border border-white/20 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            Free Inspection
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-white text-2xl cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={menuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#1a1a1a] border-t border-white/10 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-white/80 hover:text-white text-sm font-medium py-1 cursor-pointer"
              onClick={() => setMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="tel:2813779180"
            className="flex items-center justify-center gap-2 bg-[#c0392b] text-white text-sm font-semibold px-5 py-3 rounded-full mt-2 cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            Call (281) 377-9180
          </a>
        </div>
      )}
    </header>
  );
}
